export const Action = {
    //user actions
    SIGNUP: 'signup',
    LOGIN: 'login',
    LOGOUT: 'logout',
    USER_ACTION: 'user_action',
    USER_AUTHENTICATED: 'user_authenticated',
    USER_LOGGED_IN: 'user_logged_in',
    USER_ERROR: 'user_error',
    USER_ERROR_RESET: 'user_error_reset',
    FORGOT_PASSWORD_SENT: 'forgot_password_sent',
    PROFILE_IMAGE_UPLOAD_PROGRESS: 'profile_iamge_upload_progress',
    PROFILE_IMAGE_UPLOADED: 'profile_image_uploaded',
    PROFILE_IMAGE_UPLOADING: 'profile_image_uploading',
    USER_INITIAL_REQUESTS: 'user_initial_requests',
    USER_MORE_REQUESTS: 'user_more_requests',
    USER_RESET_REQUESTS: 'user_reset_requests',

    //image actions
    IMAGES_UPLOADING: 'images_uploading',
    IMAGES_UPLOAD_COMPLETE: 'images_upload_complete',
    IMAGE_UPLOAD_SUCCESS: 'image_upload_success',
    IMAGE_UPLOAD_ERROR: 'image_upload_error',
    IMAGES_UPLOAD_PROGRESS: 'images_upload_progress',
    IMAGES_RESET: 'images_reset',
    IMAGE_ADD_TO_QUEUE: 'image_add_to_queue',
    IMAGE_UPLOAD_QUEUE: 'image_upload_queue',
    IMAGE_UPLOADED: 'image_uploaded',
    IMAGE_CREATE_QUEUE: 'image_create_queue',

    //request actions
    REQUEST_CREATE: 'request_create',
    REQUEST_ADD_QUESTIONS: 'request_add_questions',
    REQUEST_ADD_IMAGES: 'request_add_images',
    REQUEST_RESET: 'request_reset',
    REQUEST_SURVEY_SENT: 'request_survey_sent',
    REQUEST_ERROR: 'request_error',
    REQUEST_DIAGNOSIS_SENT: 'request_diagnosis_sent',
    NOTIFICATION_SENT: 'notification_sent',

    //admin actions
    ADMIN_LOADING: 'admin_loading',
    //ADMIN_INITIAL_REQUESTS: 'admin_initial_requests',
    //ADMIN_MORE_REQUESTS: 'admin_more_requests',
    ADMIN_INITIAL_USERS: 'admin_initial_users',
    ADMIN_MORE_USERS: 'admin_more_users',
    ADMIN_GET_ERROR: 'admin_get_error',
    //ADMIN_CURRENT_REQUEST: 'admin_current_request',
    ADMIN_SET_DIAGNOSIS: 'admin_set_diagnosis',

    //Request List
    REQUESTS_LOADING: 'requests_loading',
    REQUESTS_INITIAL: 'requests_initial_requests',
    REQUESTS_MORE: 'requests_more_requests',
    REQUESTS_GET_ERROR: 'requests_get_error',
    REQUESTS_CURRENT_REQUEST: 'requests_current_request',
    REQUESTS_SET_DIAGNOSIS: 'requests_set_diagnosis',
    REQUESTS_INITIALIZE_DIAGNOSIS: 'requests_initialize_diagnosis',
    REQUESTS_UPDATE_DIAGNOSIS_IMAGES: 'requests_update_diagnosis_images',
    REQUESTS_UPDATE_PAYMENT: 'requests_update_payment',
}